import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import UserNotificationsListView from "./list";
import UserNotificationsAccessLevelsView from "./access-levels";
import UserNotificationSubscriptionsView from "./subscriptions";
import useAccessLevels from "../../../../hooks/use-access-levels";

const UserNotificationsView = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Listens for the changes in the url and with each change:
     * Checks the url of the route, and if its /user-notifications, appends /list to it.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.userNotifications.base, exact: true})) {
            if (operatorAccessLevels.packages.notifications.customerNotifications) {
                history.replace(routes.userNotifications.list);
            } else if (operatorAccessLevels.packages.notifications.manageCustomerNotifications) {
                history.replace(routes.userNotifications.accessLevels);
            } else {
                history.replace(routes.userNotifications.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.notifications.customerNotifications, operatorAccessLevels.packages.notifications.manageCustomerNotifications]);

    return (
        <Switch>
            <Route path={routes.userNotifications.base} exact/>
            {
                operatorAccessLevels.packages.notifications.customerNotifications &&
                <Route path={routes.userNotifications.list} exact>
                    <UserNotificationsListView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.notifications.manageCustomerNotifications &&
                <Route path={routes.userNotifications.accessLevels} exact>
                    <UserNotificationsAccessLevelsView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.notifications.manageCustomerNotifications &&
                <Route path={routes.userNotifications.subscriptions} exact>
                    <UserNotificationSubscriptionsView/>
                </Route>
            }
            <Redirect to={routes.userNotifications.base.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
}

export default UserNotificationsView;
